var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{ref:"keywordsearchChartDonut",attrs:{"height":"450","options":_vm.chartOptionsDonut,"series":_vm.series,"totalFreq":_vm.totalFreq}})}
var staticRenderFns = []

export { render, staticRenderFns }